import { Box, Typography } from '@mui/material';
import React from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { individualPanRegex, nonDigitRegex, nonIndividualPanRegex } from '../../utils/regex';
import { Location } from 'history';
import {
  CheckIFApplicationsCanBeCreated,
  getCountryCodes,
  getFieldLabelForGuardian,
  isOnboardingTypeMinor,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  ACCOUNT_TYPE_MASTER,
  FUND_FLOW_TYPE_MASTER,
  INVESTMENT_TYPE_MASTER,
  ONBOARDING_INVESTOR,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { CountryCodesDropDown } from '../commonComponents';
import UseRadioGroup from '../../lib/formik/Radio';
import theme from '../../themes';
import {
  addJointHolderWithCKYC,
  createApplicationWithCKYC,
} from '../../redux-store/actions/application';
import { Notice } from './Router';
import { useFeatureToggles } from '../../utils/useDataMdms';
export interface ValuesCKYCOnboarding {
  countryCode: string;
  countryNameAndCode: string;
  applicationType: string;
  onboardingType: string;
  mobile_number: string;
  // ckyc_number: string;
  flowType: string;
  fundFlowType: string;
  investmentType: string;
  pan: string;
}

export default function EnterCKYC({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
    flowType: string;
    fundFlowType: string;
    investmentType: string;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    application,
    flowType = '',
    fundFlowType = '',
    investmentType = '',
  } = location.state || {};
  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();

  // const ckycNumbers = applicants.map((applicant) => applicant.ckyc_number);
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile_number);
  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);

  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        const isPANWithP = fieldValue[3] === 'P';
        const isMinorOnboarding = isOnboardingTypeMinor(parent.onboardingType);
        if (isPANWithP) {
          if (!individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'Invalid PAN',
              path,
            });
          }
          if (applicantPanNumbers.includes(fieldValue)) {
            return createError({
              message:
                'There is already the same PAN for an applicant associated with this application',
              path,
            });
          }
          return true;
        } else {
          // Non-individual PAN (5th character is not 'P') - reject it
          return createError({
            message: 'Only individual PAN is allowed',
            path,
          });
        }
      }),
    mobile_number: yup.string().test('mobile_number', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      // if (
      //   !value &&
      //   ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.non_individual
      // ) {
      //   return true;
      // }
      if (!value) {
        return createError({
          message: 'Mobile number is required',
          path,
        });
      }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (applicantMobileNumbers.includes(value)) {
        return createError({
          message:
            'There is already same mobile number for an applicant associated with this application',
          path,
        });
      }
      return true;
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .test('countryNameAndCode', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === value) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (
          !value &&
          ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.non_individual
        ) {
          return true;
        }
        if (!value) {
          return createError({
            message: 'Country Code is required',
            path,
          });
        }
        if (
          parent.mobile_number &&
          !isValidPhoneNumber(
            value?.split(':')[1].trim() + parent.mobile_number,
            codesList as CountryCode
          )
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }

        return true;
      }),
    // applicationType: yup.string().nullable().required('Onboarding Investor Type is required'),
    // onboardingType: yup
    //   .string()
    //   .nullable()
    //   .when('applicationType', {
    //     is: (applicationType: string) =>
    //       ONBOARDING_INVESTOR[applicationType] === ONBOARDING_INVESTOR.individual,
    //     then: yup.string().nullable().required('Account Type is required'),
    //   }),
    onboardingType: yup.string().nullable().required('Investor Type is required'),
    // ckyc_number: yup
    //   .string()
    //   .test('ckyc_number', (value, context) => {
    //     const { createError, path } = context;
    //     if (value && applicantMobileNumbers.includes(value)) {
    //       return createError({
    //         message:
    //           'There is already same ckyc number for an applicant associated with this application',
    //         path,
    //       });
    //     }
    //     return true;
    //   })
    //   .required('CKYC number is required')
    //   .length(14, 'CKYC number must be of 14 characters'),
  });
  // console.log(location.state, 'location state in ckyc');
  const initialValues1: ValuesCKYCOnboarding = {
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    applicationType: id && redirectTo ? 'individual' : '',
    onboardingType: 'normal',
    mobile_number: '',
    // ckyc_number: '',
    pan: '',
    flowType: flowType || 'investor_with_pan',
    fundFlowType: fundFlowType || application?.fundFlowType || 'outbound',
    investmentType: investmentType || applicants[0]?.investmentType || 'retail_investment',
  };

  const handleSubmit1 = async (values: ValuesCKYCOnboarding) => {
    try {
      const {
        applicationType,
        countryNameAndCode,
        pan,
        mobile_number: mobileNumber,
        flowType,
      } = values;
      const payloadBody = {
        ...values,
        pan: pan.toUpperCase(),
        flowType,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        mobile_number: mobileNumber ? mobileNumber?.toString()?.trim() : '',
        investmentType: values?.investmentType || applicants[0]?.investmentType || '',
      };
      // console.log(payloadBody, 'payload body for ckyc onboarding');
      if (id && redirectTo) {
        const res = (await dispatch(
          addJointHolderWithCKYC(payloadBody, id)
        )) as unknown as ApplicationProps;
        history.push('enter-otp', {
          ...(res || {}),
          pan: pan.toUpperCase(),
          creationType: 'ckyc_number',
          application,
          redirectTo,
        });
        return;
      }
      const res = (await dispatch(
        createApplicationWithCKYC(payloadBody)
      )) as unknown as ApplicationProps;
      history.push('enter-otp', {
        ...(res || {}),
        pan: pan.toUpperCase(),
        creationType: 'ckyc_number',
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  const { toggler } = useFeatureToggles();
  return !CheckIFApplicationsCanBeCreated(
    toggler?.nfoDates?.length ? toggler?.nfoDates : [{ startDate: null, endDate: null }]
  ) && !id ? (
    <Notice />
  ) : (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, values, errors }) => {
          const { onboardingType } = values;
          const label = getFieldLabelForGuardian(onboardingType);
          // console.log(errors, 'formik errors');
          return (
            <>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
                  {FUND_FLOW_TYPE_MASTER[values.fundFlowType]} Type (
                  {INVESTMENT_TYPE_MASTER[values.investmentType]})
                </Typography>
                {/* <Box sx={{ mt: 1.5 }}>
                  <UseRadioGroup
                    formLabel="Onboarding Investor Type *"
                    name={`applicationType`}
                    items={Object.keys(ONBOARDING_INVESTOR)
                      .filter((_option) =>
                        id && redirectTo
                          ? ONBOARDING_INVESTOR[_option] !== ONBOARDING_INVESTOR.non_individual
                          : _option
                      )
                      .map((option) => ({
                        label: ONBOARDING_INVESTOR[option],
                        value: option,
                      }))}
                    onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                      setValues({
                        ...values,
                        applicationType: value,
                        onboardingType: 'normal',
                        mobile_number: '',
                        countryCode: '+91',
                        countryNameAndCode: 'India: +91',
                      });
                    }}
                  />
                </Box> */}
                {/* {ONBOARDING_INVESTOR[values.applicationType] === ONBOARDING_INVESTOR.individual && ( */}
                <Box sx={{ mt: 1.5 }}>
                  <UseRadioGroup
                    formLabel="Select Investor Type"
                    name={`onboardingType`}
                    items={Object.keys(ACCOUNT_TYPE_MASTER).map((option) => ({
                      label: ACCOUNT_TYPE_MASTER[option],
                      value: option,
                    }))}
                    disabled={!!id}
                  />
                </Box>
                {/* )} */}

                <MFTextField
                  label={`${label} PAN`}
                  name="pan"
                  placeholder="Enter PAN"
                  required
                  autoComplete="off"
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                />

                {/* <MFTextField
                  label={`${label} CKYC Number`}
                  infoText={`Give a missed call from CKYC registered mobile no. on 7799022129 to get your CKYC number`}
                  name="ckyc_number"
                  placeholder="Enter CKYC number"
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  regexForFilterValue={nonDigitRegex}
                /> */}
                <MFTextField
                  label={`${label} Mobile Number`}
                  infoText={`CKYC registered mobile no.`}
                  name="mobile_number"
                  placeholder="Enter Mobile number"
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  startAdornment={
                    <CountryCodesDropDown
                      name={'countryNameAndCode'}
                      value={values.countryNameAndCode}
                    />
                  }
                  regexForFilterValue={nonDigitRegex}
                />
                {/* <Typography sx={{ fontWeight: 500, fontSize: '12px', letterSpacing: -1 }}>
                  Don’t have an CKYC Number or Registered Mobile Number? Click here
                </Typography> */}
                {/* <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '13px',
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                  }}>
                  Please enter the mobile number registered with CKYC
                </Typography> */}
                <MFSubmitButton label={'Proceed'} />
              </Box>
            </>
          );
        }}
      </Formik>
    </>
  );
}
